import { useEffect } from "react"

const URL = "https://assets.suraasa.com/lms/suraasa-se-rich-text.css"

const className = "suraasa-se-rich-text"

export const useSkillEvidenceStyles = () => {
  useEffect(() => {
    if (!URL) return

    const existingLink = document.querySelector(
      `link[href="${URL}"]`
    ) as HTMLLinkElement | null

    if (existingLink) return

    const link = document.createElement("link")
    link.rel = "stylesheet"
    link.type = "text/css"
    link.href = URL

    document.head.appendChild(link)

    return () => {
      document.head.removeChild(link)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [URL])

  return { className }
}
